/*
 * @Description:
 * @Author: 宋信峰
 * @Date: 2022-08-11 14:05:44
 * @LastEditTime: 2022-09-23 10:36:50
 * @LastEditors: 宋信峰
 * @Reference:
 */
import request from "./http";

export function lists(data = {}) {
  const params = {
    prov_id: data.prov_id || null,
    mold_id: data.mold_id || null,
    mold_ids: data.mold_ids || null,
    is_recommend: data.is_recommend || 0,
    search: data.search || null,
    search_file: data.search_file || null,
    page: data.page || 1,
    page_size: data.page_size || 8,
    store_type: data.store_type || null
  };
  return request.post("html/index/caseShow", params);
}

export function detal(data) {
  return request.post("html/caseller/caseDetail", data);
}

export function myList(data = {}) {
  return request.post("html/user/myCase", data);
}

export function create(data) {
  return request.post("html/Release/caseRelease", data);
}

export function edit(data) {
  return request.post("html/user/editMyCase", data);
}

export function edtiDetal(data) {
  return request.post("html/user/myCaseDetail", data);
}

export function deleteCase(data) {
  return request.post("html/User/delMyCase", data);
}
export function topCase(data) {
  const params = {
    page: data.page || 1,
    page_size: data.page_size || 8
  };
  return request.post("html/Index/caseTop", params);
}
